import FJRenderState from './FJRenderState';

class FJExportLayer {
    /**
     * @desc 构造函数
     * @param props
     */
    constructor(props) {
        this._errMsg = null;
        this._status = FJRenderState.IDLE;
        this._callback = props.callback;
    }

    start() {}

    /**
     * @desc 当前层是否准备好
     * @return {boolean}
     */
    prepared() {
        return true;
    }

    /**
     * @desc 清理
     */
    clear() {}

    /**
     * @desc 绘制到画布
     * @param canvas
     */
    drawToCanvas() {}

    get errMsg() {
        return this._errMsg;
    }

    /**
     * @desc 返回当前状态是否可以渲染
     * @returns {boolean}
     */
    get canDraw() {
        return this._status === FJRenderState.DONE;
    }

    /**
     * @desc 渲染完成
     * @private
     */
    _done() {
        if (this._status !== FJRenderState.RENDERING) return;

        this._status = FJRenderState.DONE;

        if (this._callback) this._callback();
        this._callback = null;
    }

    /**
     * @desc 渲染出错
     * @param errMsg
     * @private
     */
    _error(errMsg) {
        if (this._status !== FJRenderState.RENDERING) return;

        this._status = FJRenderState.ERROR;
        this._errMsg = errMsg;

        if (this._callback) this._callback(errMsg);
        this._callback = null;
    }
}

export default FJExportLayer;
